import { Component, OnInit, ViewChild } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { Address } from '../address/address';
import { add } from 'ngx-bootstrap/chronos/public_api';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute,NavigationEnd, Router } from "@angular/router";


@Component({
  selector: 'app-premium',
  templateUrl: './premium.component.html',
  styleUrls: ['./premium.component.css']
})



export class PremiumComponent implements OnInit {
  @ViewChild('stepper') private myStepper: MatStepper;
  typeConfirmation;

  constructor(private _formBuilder: FormBuilder,private titleService: Title, private route: ActivatedRoute, private activatedRoute : ActivatedRoute, private router: Router) {
    this.titleService.setTitle("Premium - VirtualRacesFrance"); 
  }

  address;
  order;
  date;
  type;


  ngAfterViewInit() {
    this.checkParam();
  }

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.checkParam();
      }
    });
  }

  onSaved(address: any) {
    this.address = address;
    this.goToStep(2);
  }

  onConfirmed(order: any){
    this.order = order;
    this.date = new Date(order.create_time).toDateString();
    this.goToStep(3);
  }

  goToStep(index) {
    this.myStepper.selectedIndex = index;
  }

  checkParam(){
        this.route.queryParams.subscribe(async(params) => {
          if(params['info'] == 1 || params['info'] == 2 || params['info'] == 3){
            if(params['info'] == 1 || params['info'] == 3){
              localStorage.setItem("maplerace_isPrenium", "true");
            }
            this.goToStep(1);
            this.goToStep(2);
            this.goToStep(3);
            this.typeConfirmation = params['info'];
          }
          if(params['type'] == "gift"){
            this.type = params['type']; 
          }else{
            this.type = "";
          }
      });
  }



}
